import { useEffect, useState } from 'react';

export default function useMediaQuery(query: string) {
  const [state, setState] = useState(window.matchMedia(query).matches);

  useEffect(() => {
    const mql = window.matchMedia(query);

    const onChange = (e: MediaQueryListEvent) => {
      setState(!!e.matches);
    };

    mql.addEventListener('change', onChange);
    setState(mql.matches);

    return () => {
      mql.removeEventListener('change', onChange);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return state;
}
